import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styles from './Input.module.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error = false, fullWidth = false, className = '', ...props }, ref) => {
    const classNames = [
      styles.input,
      error && styles.error,
      fullWidth && styles.fullWidth,
      className,
    ].filter(Boolean).join(' ');

    return (
      <input
        ref={ref}
        className={classNames}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

